// Import
import SalesMenu from './SalesMenu';
import SidebarLayout from '../shared/SidebarLayout';

function SalesLayout() {
  return (
    <SidebarLayout MenuComponent={SalesMenu} />
  );
}
export default SalesLayout;
